import React from "react";
import "./Button.css";

function Button({ children, onPress }) {
  return (
    <div onClick={onPress} className="button">
      {children}
    </div>
  );
}

export default Button;
